import { BaseLandscapeService } from '../../base-landscape.service';
import {
  getLanguageKey,
  LocalesLanguagesConstants,
} from '../../../../locales/locales';
import { LandscapeTypeResponseDto } from '../dto/landscape-type-response.dto';
import { LandscapeTypeSaveRequestDto } from '../dto/landscape-type-save-request.dto';

class TypeService extends BaseLandscapeService {
  public async fetchTypes(): Promise<LandscapeTypeResponseDto[]> {
    const response = await this.get<LandscapeTypeResponseDto[]>(`/compacttype`);
    return response.data;
  }

  public async fetchTypeById(
    id: string,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<LandscapeTypeResponseDto> {
    const response = await this.get<LandscapeTypeResponseDto>(
      `/compacttype/${id}`,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async saveType(
    saveRequest: LandscapeTypeSaveRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<LandscapeTypeResponseDto> {
    const response = await this.post<LandscapeTypeResponseDto>(
      `/compacttype`,
      saveRequest,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async updateType(
    id: string,
    updateRequest: LandscapeTypeSaveRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<LandscapeTypeResponseDto> {
    const response = await this.put<LandscapeTypeResponseDto>(
      `/compacttype/${id}`,
      updateRequest,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async deleteType(existingId: string): Promise<void> {
    await this.delete<void>(`/compacttype/${existingId}`);
  }
}

const typeService = new TypeService();
export default typeService;
